// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

// 🔐 Replace with your own config (from Firebase Console > Project Settings)
const firebaseConfig = {
    apiKey: "AIzaSyDy152jkYklRNnxg0g95xL5uG5VDqEGjXM",
    authDomain: "mypmr-70eed.firebaseapp.com",
    databaseURL: "https://mypmr-70eed-default-rtdb.firebaseio.com",
    projectId: "mypmr-70eed",
    storageBucket: "mypmr-70eed.firebasestorage.app",
    messagingSenderId: "577795964936",
    appId: "1:577795964936:web:44e9f76336726e2582d1bd",
    measurementId: "G-H28XPHFVZW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export auth and db
const auth = getAuth(app);
const db = getDatabase(app);

export { auth, db };
